export default __webpack_public_path__ + "static/media/doctor.c80616e9.png";